"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));
var _envConstants = require("../constants/envConstants");
var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));
var _ShipmentPlanAnalysisViewerBody = _interopRequireDefault(require("./ShipmentPlanAnalysisViewerBody"));
var _react2 = require("@emotion/react");
/* eslint-disable react/forbid-prop-types,consistent-return */

var ShipmentPlanAnalysisViewer = function ShipmentPlanAnalysisViewer(props) {
  return (0, _react2.jsx)(_ErrorBoundary["default"], null, (0, _react2.jsx)(_ShipmentPlanAnalysisViewerBody["default"], props));
};
ShipmentPlanAnalysisViewer.propTypes = {
  className: _propTypes["default"].string,
  style: _reactStyleProptype["default"],
  accessToken: _propTypes["default"].string.isRequired,
  itemUrl: function itemUrl(props, propName, componentName) {
    if (!props.itemUrl && (0, _isEmpty2["default"])(props.item)) {
      return new Error("'itemUrl' or 'item' prop must be provided to ".concat(componentName));
    }
    if (props.itemUrl && !props.itemUrl.startsWith('https://item-service.commerce.cimpress.io')) {
      return new Error("".concat(propName, " must be a valid item URL"));
    }
  },
  item: _propTypes["default"].object,
  env: _propTypes["default"].oneOf([_envConstants.PRD, _envConstants.INT]),
  showBasicInfo: _propTypes["default"].bool
};
ShipmentPlanAnalysisViewer.defaultProps = {
  className: undefined,
  style: undefined,
  itemUrl: '',
  item: {},
  env: _envConstants.PRD,
  showBasicInfo: true
};
var _default = exports["default"] = ShipmentPlanAnalysisViewer;